<template>
  <div v-if="geogrid.obfuscatedId || geogrid.id" class="d-flex gap-1 row inmap bottom left">
    <div class="geogrid-info">
      <div class="label">Created:</div>
      <div class="data">{{ formatDate }}</div>
    </div>
    <div class="geogrid-info">
      <div class="label">Google region:</div>
      <div class="data">
        <span v-if="geogrid.attrs.localLanguageEnabled && geogrid.attrs.businessCountry">{{ geogrid.attrs.businessCountry }}</span>
        <span v-else>Global</span>
      </div>
    </div>
    <div class="geogrid-info">
      <div class="label">Grid:</div>
      <div class="data">{{ geogrid.attrs.gridFormatted }}</div>
    </div>
    <div class="d-flex align-items-center gap-2 geogrid-info">
      <div v-for="{ name, value } in metrics" :key="name">
        <div class="label">{{ name }}:</div>
        <div class="data">{{ value }}</div>
      </div>
      <div>
        <i class="far fa-info-circle" id="ranks-explanation" />
        <b-popover
          placement="top"
          target="ranks-explanation"
          custom-class="ranks-explanation-popover"
          triggers="hover">
          <div class="ranks-explanation">
            <div>
              <b class="color-dark font-size-14 font-weight-semi-bold">AGR</b>
              <p class="text-muted font-size-12 m-0">
                Average Grid Rank. Only nodes with ranks equal to "20" and less considered.
              </p>
            </div>
            <div>
              <b class="color-dark font-size-14 font-weight-semi-bold">ATGR</b>
              <p class="text-muted font-size-12 m-0">
                Average Total Grid Rank. All nodes considered. The "21" value is used for nodes with ranks over "20".
              </p>
            </div>
            <div>
              <b class="color-dark font-size-14 font-weight-semi-bold">SoLV</b>
              <p class="text-muted font-size-12 m-0">
                Share of Local Voice indicates the percentage of search nodes where your business ranks "3" or better.
                A higher value, close to 100%, signifies a stronger market presence.
              </p>
            </div>
          </div>
        </b-popover>
      </div>
    </div>

    <a v-if="show3dLink" class="d-flex align-items-center gap-2 geogrid-info" :href="`/geogrids/${geogrid.obfuscatedId || geogrid.id}/view_3d`">
      <i class="far fa-cube" />
    </a>
  </div>
</template>

<script>
// TODO: after release replace /app/javascript/src/vue_widgets/geogrids/map/geogrid_info.vue
// with this file and pass geogrid as props where needed

import { BPopover } from 'bootstrap-vue'
import formatISODatetime from '../../helpers/formatters'

export default {
  props: {
    geogrid: { type: Object, requred: true },
    show3dLink: { type: Boolean, default: false }
  },
  components: { BPopover },
  computed: {
    formatDate() {
      return formatISODatetime(this.geogrid.createdAt, 'fullWithTZ')
    },
    metrics() {
      const NA = 'N/A'
      const round = (num) => Math.round(num * 100) / 100
      const format = (num) => (parseFloat(num) ? round(num) : NA)
      const fixValue = (value) => {
        const formattedValue = format(value)
        return formattedValue !== NA ? formattedValue.toFixed(2) : formattedValue
      }
      return [
        {
          name: 'AGR',
          value: fixValue(this.geogrid.agr)
        },
        {
          name: 'ATGR',
          value: fixValue(this.geogrid.atgr)
        },
        {
          name: 'SoLV',
          value: this.geogrid.solv ? `${(round(this.geogrid.solv) * 100).toFixed(0)}%` : '0%'
        }
      ]
    }
  }
}
</script>
